import { render, staticRenderFns } from "./LECO_UserRegistration.vue?vue&type=template&id=e2ab463a&scoped=true"
import script from "./LECO_UserRegistration.vue?vue&type=script&scoped=true&lang=js"
export * from "./LECO_UserRegistration.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./LECO_UserRegistration.vue?vue&type=style&index=0&id=e2ab463a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ab463a",
  null
  
)

export default component.exports